import { isDownloadLink } from "../../../frontend/js/link-helpers";
import Analytics from "../../../frontend/js/analytics";


class CampaignDatalayerEvents {
    constructor() {
        this.lastCardEventTriggered = null;
        this.cardNavigationButtons = document.querySelectorAll('.campaign-cards button');
        this.cardHolderLinks = document.querySelectorAll('.campaign-cards a');
        this.quoteNavigationButtons = document.querySelectorAll('.quote-carousel button');
        this.heroVideoButtons = document.querySelectorAll('.campaign-hero__video-button-wrapper');
        this.forms = document.querySelectorAll('.campaign .form-block__form form');
        this.faqsToggleButtons = document.querySelectorAll('.campaign .faq-item__toggler');
        this.interactiveCalendarCards = new Set([...document.querySelectorAll('.campaign .interactive-calendar__timeline-item')]);
        this.ctaButtons = [...document.querySelectorAll(".campaign-hero__buttons-container a, .content-block__column a")];
        this.addEventListeners();
    }

    addEventListeners() {

        this.forms.forEach((element) => {
            const formSubmissionButton = element.querySelector('.campaign .form-block__form form button')
            formSubmissionButton.addEventListener("click", e => {
                let title = element.querySelector(
                    '.Form__Title').innerText
                const validationFail = element.querySelector(
                    '.ValidationFail')
                let isValid = !!!validationFail

                title = title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();

                isValid ? dataLayer.push({
                    'event': 'formSubmission',
                    'formSubmissionHeadline': title,
                    'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
                    'selectedBranch': this.getBranchName()
                }) : null
            })
        })

        this.cardNavigationButtons.forEach((element) => {
            element.addEventListener("click", e => {
                let wrapper = element.closest('.campaign-cards__wrapper')
                let title = wrapper.querySelector('.campaign-cards__title').innerText.toLowerCase()
                title = title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();
                dataLayer.push({
                    'event': 'CarouselArrow',
                    'ModuleHeadline': title,
                    'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
                    'selectedBranch': this.getBranchName()
                })
            })
        })

        this.cardHolderLinks.forEach((element) => {
            element.addEventListener("click", e => {
                var title = element.querySelector('.campaign-card__heading').innerText.toLowerCase();
                title = title.charAt(0).toUpperCase() + title.slice(1).toLowerCase();

                dataLayer.push({
                    'event': 'cardholderLinkClick',
                    'cardholderLinkClickHeadline': title,
                    'cardholderLinkClickUrl': element.href,
                    'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
                    'selectedBranch': this.getBranchName()
                });
            });
        });

        this.quoteNavigationButtons.forEach((element) => {
            element.addEventListener("click", e => {
                dataLayer.push({
                    'event': 'CarouselArrowQuote',
                    'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
                    'selectedBranch': this.getBranchName()
                });
            })
        });

        this.heroVideoButtons.forEach((element) => {
            element.addEventListener("click", e => {
                dataLayer.push({
                    'event': 'PlayButton',
                    'PlayButtonClickText': element.querySelector(
                        '.campaign-hero__video-button-description-text').innerText,
                    'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
                    'selectedBranch': this.getBranchName()
                });
            })
        })
        let self = this;
        this.interactiveCalendarCards.forEach((element) => {
            if (!element.dataset.card) {
                console.log('No data-card attribute found on element')
                return;
            }

            element.addEventListener("changedcard", e => {
                if (self.lastCardEventTriggered === e.cardNumber) {
                    console.log('Card event already triggered')
                    return;
                }

                self.lastCardEventTriggered = e.cardNumber;
                dataLayer.push({
                    'event': 'cardholderSwipeClick',
                    'cardholderSwipeCard': `${e.cardNumber} av ${e.totalCards}`,
                });
            })
        })

        this.ctaButtons.filter(x => !isDownloadLink(x)).forEach((ctaButton) => ctaButton.addEventListener("click", Analytics.campaignCtaClick));

    }
    getBranchName() {
        const branchBtn = document.querySelector('.branch__open');
        if (!branchBtn) return
        let branchName = branchBtn.innerText
        return branchName === 'VÄLJ BRANSCH' ? null : branchName.charAt(0).toUpperCase() + branchName.slice(1).toLowerCase()
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new CampaignDatalayerEvents();
});
